import { envConfig } from '../../envConfig'

const webUrlBase = envConfig.url.API_URL

export const urlGetDeliveryURL = `${webUrlBase}api/web/restaurants/delivery_table_from_host`
export const urlGetHomeUrl = `${webUrlBase}api/mobile/home/page`
export const urlCheckForHome = `${webUrlBase}api/mobile/restaurants/check_for_home`;
